import QuoteTerms from './QuoteTerms'

export default QuoteTerms
